import { Component, OnInit } from '@angular/core';
import { VerifyData } from './verify-data';
import { Router, ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { SendMessageService } from '../send-message.service';

@Component({
  selector: 'app-verify-screen',
  templateUrl: './verify-screen.component.html',
  styleUrls: ['./verify-screen.component.scss']
})
export class VerifyScreenComponent implements OnInit {
  code: string;
  id: string;
  verifyData: VerifyData;
  constructor(private appComponent: AppComponent, private sendMessage: SendMessageService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.appComponent.client.subscribe('verify/' + this.id + '/res');
  }

  verify(): void {
    const verifyData: VerifyData = new VerifyData(this.code, this.id);
    const message = JSON.stringify(verifyData);
    this.sendMessage.sendMessage(this.appComponent.client, message, 'verify');
  }
}
